import { Image } from "antd";
import React from "react";

export default function Logo() {
  return (
    <Image preview={false} src={"/logo.jpeg"} alt="ziraatBayi" width={"100%"} />
  );
}
